export interface MenuItem {
  is_mat_icon: boolean;
  icon: string;
  key: string;
  external_type?: string;
  hidden?: boolean;
}

export enum LEFT_MENU {
  'SETTINGS' = 'SETTINGS',
}

export enum RIGHT_MENU {
  'ABOUT' = 'ABOUT',
}

export interface ChatsSidebarPayload {
  chatId?: string;
}
